import { React, useState, useEffect } from "react";
import "./navbar.css";
import { Link } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import AnimatedLogo from "../AnimatedLogo/AnimatedLogo";
import { useNavigate, useLocation } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

const navLinks = [
  { label: "About Us", href: "#about" },
  { label: "Team", href: "#team" },
  { label: "Career", href: "#career" },
  { label: "Contact Us", href: "#contact" },
];

const NavbarComp = () => {
  const email = localStorage.getItem("email");
  const location = useLocation();
  const isSimpleHeaderPage =
    /^\/blog\//i.test(location.pathname) ||
    location.pathname === "/saarthi/tnc" ||
    location.pathname === "/login";
  const showSimpleHeader = Boolean(email) || isSimpleHeaderPage;
  const [opacity, setOpacity] = useState(1);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (showSimpleHeader) return undefined;

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const newOpacity = Math.max(0.7, 1 - scrollPosition / 300);
      setOpacity(newOpacity);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showSimpleHeader]);

  const removeDataFromLocalStorage = () => {
    localStorage.removeItem("email");
    navigate("/");
    window.location.reload();
  };

  const handleNavLinkClick = (e, href) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  if (showSimpleHeader) {
    return (
      <div className="home-header logged-in-header">
        <header
          data-thq="thq-navbar"
          className="navbarContainer home-navbar-interactive"
        >
          <Link to="/" style={{ textDecoration: "none" }}>
            <AnimatedLogo
              color="#fff"
              showTiles={false}
              enableScrollAnimation={false}
              popOnMount={true}
            />
          </Link>
          <div data-thq="thq-navbar-nav" className="home-desktop-menu">
            <nav className="home-links">
              <Link to="/" style={{ textDecoration: "none" }}>
                <span className="home-nav12 bodySmall home-link">
                  Home
                  <img
                    src="/images/home-icon.png"
                    alt="home"
                    className="home-icon"
                  />
                </span>
              </Link>
            </nav>
            <div className="home-buttons">
              {email === "team@vidyamai.com" ? (
                <Link to="/magic">
                  <CgProfile className="profileIcon" />
                </Link>
              ) : email === "sales@vidyamai.com" ? (
                <Link to="/sales-magic-chat">
                  <CgProfile className="profileIcon" />
                </Link>
              ) : null}
              {email ? (
                <button
                  className="log-out-btn"
                  onClick={removeDataFromLocalStorage}
                >
                  Log Out
                </button>
              ) : (
                <Link to="/login" className="log-out-btn">
                  Login / Sign Up
                </Link>
              )}
            </div>
          </div>
        </header>
      </div>
    );
  }

  return (
    <div className="home-header" style={{ opacity: opacity }}>
      <header
        data-thq="thq-navbar"
        className="navbarContainer home-navbar-interactive"
      >
        <div className="home-mobile-bar">
          <button
            className="hamburger-btn"
            aria-label="Toggle navigation menu"
            onClick={() => setMobileMenuOpen((prev) => !prev)}
          >
            {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
          <Link to="/" style={{ textDecoration: "none" }} onClick={() => setMobileMenuOpen(false)}>
            <img
              src="/images/textonly_logo.png"
              alt="Vidyam AI"
              className="navbar-logo-image mobile-logo"
            />
          </Link>
          <div className="home-mobile-actions">
            <Link
              to="/login"
              className="navbar-cta mobile-cta"
              onClick={() => setMobileMenuOpen(false)}
            >
              Login/Sign Up
            </Link>
          </div>
        </div>
        {mobileMenuOpen && (
          <nav className="mobile-menu">
            {navLinks.map((item) => (
              <a
                key={item.label}
                className="navbar-link mobile-link"
                href={item.href}
                onClick={(e) => {
                  handleNavLinkClick(e, item.href);
                  setMobileMenuOpen(false);
                }}
              >
                {item.label}
              </a>
            ))}
          </nav>
        )}

        <Link to="/" style={{ textDecoration: "none" }} className="desktop-logo">
          <img
            src="/images/textonly_logo.png"
            alt="Vidyam AI"
            className="navbar-logo-image"
          />
        </Link>
        <div data-thq="thq-navbar-nav" className="home-desktop-menu">
          <nav className="navbar-links">
            {navLinks.map((item) => (
              <a
                key={item.label}
                className="navbar-link"
                href={item.href}
                onClick={(e) => handleNavLinkClick(e, item.href)}
              >
                {item.label}
              </a>
            ))}
          </nav>
          <div className="home-buttons">
            <Link to="/login" className="navbar-cta">
              Login/Sign Up
            </Link>
          </div>
        </div>
      </header>
    </div>
  );
};

export default NavbarComp;
